import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { UserData } from 'app/shared/service/UserService';
import { catchError } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';
import { ApiService } from './api.service';
import { AlertMessage } from 'app/shared/utils/alertMessage';
import { throwError } from 'rxjs';
import { HelperService } from './helper.service';
import { ReactMobileService } from './react-mobile.service';
export {};

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  header: any;
  alertStatus = false;

  constructor(
    private api: ApiService, 
    private keycloakService: KeycloakService,
    private helperService: HelperService,// SG-8399
    private reactmobileservice: ReactMobileService
  ) { }

  public getHeader(request) {
    console.log("Get Header")
    let authorizationString = "Bearer " + UserData.token;
    let orgId = UserData.organizationId ? UserData.organizationId : localStorage.getItem('organizationId') ? localStorage.getItem('organizationId') : ''
     const isMobileDevice = this.helperService.getIsMobileDevice();
     const mobileLoginData = this.helperService.getMobileLoginData();
     if(isMobileDevice && mobileLoginData.nickName) {
      const httpOptions = {
        headers: request.headers.set('Authorization',authorizationString)
        .set('Nickname', mobileLoginData.nickName)
        .set('organizationId', orgId )
        .set('gameId',localStorage.getItem('gameId') ? localStorage.getItem('gameId') : '')
      };
      return httpOptions;
     } else {
       const httpOptions = {
        headers: request.headers.set('Authorization',authorizationString)
        .set('organizationId', orgId )
        .set('gameId',localStorage.getItem('gameId') ? localStorage.getItem('gameId') : '')
      };
      return httpOptions;
    }
  }

  private getUpdatedHeader(url: string) {
    let orgId = UserData.organizationId ? UserData.organizationId : localStorage.getItem('organizationId') ? localStorage.getItem('organizationId') : '';
    const isMobileDevice = this.helperService.getIsMobileDevice();
    const mobileLoginData = this.helperService.getMobileLoginData();
    if(isMobileDevice && mobileLoginData.nickName) {
    const headers: any = {
        'Nickname': mobileLoginData.nickName,
        'organizationId': orgId,
        'gameId': localStorage.getItem('gameId') ? localStorage.getItem('gameId') : ''
      };
      if (UserData.token && !url.includes('/nickNameLogin')) {
        headers['Authorization'] = 'Bearer ' + UserData.token;
      }
      return headers;
    } else {
      const headers: any = {
        'organizationId': orgId,
        'gameId': localStorage.getItem('gameId') ? localStorage.getItem('gameId') : ''
      };
      if (UserData.token && !url.includes('/nickNameLogin')) {
        headers['Authorization'] = 'Bearer ' + UserData.token;
      }
      return headers;
    }
  }

  async logmeout() {
    const currentURL = window.location.href;
    let baseURL;
    if (currentURL.includes('#')) {
      baseURL = currentURL.substring(0, currentURL.indexOf('#'));
    } else {
      baseURL = currentURL;
    }
     const redirectURI = baseURL;
    localStorage.clear();
    this.api.notifyInfo(AlertMessage.exitingCurrentSession);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): any {
    let updatedRequest = request.clone();
    
    const headers = this.getUpdatedHeader(request.url);
      updatedRequest = request.clone({
        setHeaders: headers
    });
    
    return next.handle(updatedRequest)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error instanceof HttpErrorResponse) {
            this.checkError(error)
          }
          return throwError(error.error);
    }));
  }

  async logmeoutNoAccessRights() {
    const currentURL = window.location.href;
    let baseURL;
    if (currentURL.includes('#')) {
      baseURL = currentURL.substring(0, currentURL.indexOf('#'));
    } else {
      baseURL = currentURL;
    }
     const redirectURI = baseURL;
    localStorage.clear();
    this.api.notifyError(AlertMessage.logoutBasedOnRoll);
    await this.keycloakService.logout(redirectURI);
  } 

  async checkError(err) {
    //start SG-8399
    const isMobileDevice = this.helperService.getIsMobileDevice();
    if (isMobileDevice) {
      if (err.status === 401) {
        this.reactmobileservice.responseFromWeb("Session Expired", true, true, false); 
      }
      return err;
    }
    //end SG-8399
    if(err.status==0 && err.url.includes("/v1/token")){
      this.logmeoutNoAccessRights();
    }
    if (await this.keycloakService.isLoggedIn()) {
      if (window.location.href.includes('multiGamePlay')) {
        if (!this.alertStatus) {
          this.alertStatus = true;
        }
      }
      return err;
    } else if (!window.location.href.includes('live-session') && !window.location.href.includes('share')) {
      this.logmeout();
    }
  }

}
